<template>
  <div>
    <div
      v-if="marketing"
      class="c-social-posts-carousel"
    >
      <ul
        class="juicer-feed"
        :data-feed-id="feedId"
        :data-per="pageSize"
        :data-pages="pageLimit"
        :data-truncate="contentMaxLength"
        :data-columns="columns"
        :data-interval="slideInterval"
        data-style="slider"
        data-overlay="false"
      />
    </div>
    <div v-if="!marketing">
      <onetrust-blocker />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'c-social-posts-carousel',
  props: {
    pageSize: {
      default: 40,
    },
    pageLimit: {
      default: 4,
    },
    contentMaxLength: {
      default: 200,
    },
    columns: {
      default: 4,
    },
    slideInterval: {
      default: 0,
    },
    feedId: {
      type: String,
      default: ''
    },
    readMore: {
      type: String,
    }
  },
  data() {
    return {
      section: null
    }
  },
  computed: {
    ...mapGetters('onetrust', [
      'marketing'
    ])
  },
  mounted() {
    const juicerScript = document.createElement('script')
    juicerScript.type = 'text/javascript'
    juicerScript.src = 'https://assets.juicer.io/embed.js'

    const juicerCss = document.createElement('link')
    juicerCss.media = 'all'
    juicerCss.rel = 'stylesheet'
    juicerCss.type = 'text/css'
    juicerCss.href = 'https://assets.juicer.io/embed.css'

    this.$el.appendChild(juicerScript)
    this.$el.appendChild(juicerCss)

    document.addEventListener('DOMContentLoaded', () => {
      const socialPostsContainer = document.querySelector('.c-social-posts-carousel--container')
      if (socialPostsContainer) {
        const titleElement = socialPostsContainer.querySelector('.title')
        this.section = titleElement.length > 0 ? titleElement.innerText : 'Social Posts Carousel'

        const startTime = new Date()
        const interval = setInterval(() => {
          const currentTime = new Date()
          if ((currentTime - startTime) === (1000 * 60)) { // 1 minuto
            clearInterval(interval)
            return
          }
          const jMessageLinks = socialPostsContainer.querySelectorAll('.j-message a')
          const jMetaLinks = socialPostsContainer.querySelectorAll('.j-meta a')

          if (jMessageLinks.length && jMetaLinks.length) {
            if (jMessageLinks) {
              jMessageLinks.forEach(this.AddMessageLinkClickListener)
            }

            if (jMetaLinks) {
              jMetaLinks.forEach(this.AddMetaLinkClickListener)
            }

            this.readMoreText()
            clearInterval(interval)
          }
        }, 1000)
      }
    })
  },
  methods: {
    AddMessageLinkClickListener(messageLink) {
      messageLink.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'click',
          name: 'link-view',
          section: this.section,
          component_type: 'link',
          link_url: messageLink.href,
          outbound: true
        })
      })
    },
    AddMetaLinkClickListener(metaLink) {
      metaLink.addEventListener('click', () => {
        window.dataLayer.push({
          event: 'click',
          name: 'logo-view',
          section: this.section,
          component_type: 'logo',
          link_url: metaLink.href,
          outbound: true
        })
      })
    },
    readMoreText() {
      const readMore = document.querySelectorAll('.j-read-more')
      readMore.forEach(elemento => {
        elemento.innerText = this.readMore
      })
    }
  }
}
</script>

<style lang="scss">
  .c-social-posts-carousel--container {
    .title {
      font-weight: bold;
      font-size: 2em;
      margin-bottom: 1.25rem;

      &.left {
        text-align: left;
        padding-left: calc(3.125rem + .5rem);
      }

      &.center {
        text-align: center;
      }

      &.right {
        text-align: right;
        padding-right: calc(3.125rem + .5rem);
      }
    }
  }

  .c-social-posts-carousel {
    $text-color: black;

    .juicer-feed {
      font-family: "Montserrat", sans-serif;

      .j-twitter-bg,
      .j-facebook-bg,
      .j-instagram-bg,
      .j-linkedin-bg {
        background-color: $white;
      }

      .slick-track {
        display: flex !important;
        align-items: flex-start !important;
        gap: 1.875rem !important;
        height: unset !important;
        padding: 0 0 10rem !important;

        @media screen and (min-width: 1024px) {
          gap: 2.5rem !important;
        }
      }

      .slick-arrow {
        background-color: $blue-03 !important;
        margin: 0 2rem 7.875rem !important;
      }

      .slick-prev {
        transition: left 0.2s ease;
        padding: unset !important;

        &:hover {
          left: 0 !important;
        }
      }

      .slick-next {
        transition: right 0.2s ease;
        padding: unset !important;
        &:hover {
          right: 0 !important;
        }
      }

      .slick-next, .slick-prev {
        top: unset !important;
        width: 4.5rem !important;
        height: 4.5rem !important;

        &::before {
          font-size: 3rem !important;
        }
      }

      li.feed-item {
        box-sizing: border-box;
        border: solid 0.063rem !important;
        border-color: $neutral-04 !important;
        display: flex;
        flex-direction: column;
        height: unset !important;
        width: 17.5rem !important;

        @media screen and (min-width: 375px) {
          width: 20.938rem !important;
        }

        @media screen and (min-width: 1024px) {
          width: 25.5rem !important;
        }

        &.j-twitter {
          padding-top: 2.5rem !important;

          .j-image {
            margin-top: 0.5rem;
          }

          .j-twitter-intents {
            filter: brightness(0.5);
          }

          .j-twitter-quote {
            margin-top: 0.625rem;

            & > br {
              display: none;
            }
            .j-twitter-quote-screen-name {
              margin: 0 0 0.625rem 0.1rem;
              font-size: 0.9em;
            }
          }

          .j-poster a {
            width: unset;
          }

          .j-twitter-post-icon {
            display: flex;
            &:before {
              color: #55acee;
              font-size: 1.5rem;
            }
          }
        }

        &.j-instagram {
          .j-instagram-text-hover {
            background-clip: text !important;
            -webkit-background-clip: text !important;
            color: transparent;
            background: #d6249f;
            background: radial-gradient(
              circle at 30% 107%,
              #fdf497 0%,
              #fdf497 5%,
              #fd5949 45%,
              #d6249f 60%,
              #285aeb 90%
            );
          }
        }

        &.j-facebook {
          .j-facebook-text-hover::before {
            color: #3b5998;
          }
        }

        &.j-linkedin {
          .j-linkedin-text-hover {
            color: #007bb6;
          }
        }

        .j-text {
          position: static !important;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          background: none !important;
          padding: 1rem !important;
          text-align: left;
          opacity: 1;
          visibility: visible;
          height: 16.188rem;

          @media screen and (min-width: 1024px) {
            padding: 1.5rem !important;
          }

          &::before {
            height: unset !important;
          }
        }

        .j-image {
          position: relative !important;
          display: flex;
          align-items: center;
          height: 100%;

          @media screen and (min-width: 1024px) {
            height: 25.438rem !important;
            width: 25.438rem !important;
          }

          img {
            top: 0 !important;
            transform: none !important;
            position: static !important;
            height: 100% !important;
          }

          &.playing + .j-text {
            visibility: visible !important;
            opacity: 1 !important;
          }
        }

        .j-poster {
          display: none;
        }

        .j-meta {
          display: flex;
          justify-content: center;
          margin: 0 !important;
          position: relative !important;
          padding: unset;

          @media screen and (min-width: 1024px) {
            justify-content: unset;
          }

          a.j-social {
            font-size: 1.5rem;
            &::before {
              margin-right: 0;
            }
          }

          .j-date,
          .j-twitter-date {
            color: $text-color !important;
            font-weight: lighter;
          }
        }

        .j-message {
          position: relative !important;
          transform: none !important;
          top: unset !important;
          max-height: unset !important;
          padding: 0.5rem 0 !important;
          overflow: hidden;
          font-size: 0.875rem !important;
          font-weight: normal !important;
          line-height: 150% !important;

          @media screen and (min-width: 1024px) {
            font-size: 1rem !important;
          }

          p,
          .j-twitter-quote-text {
            height: unset;
            color: $neutral-02 !important;
            text-overflow: ellipsis !important;
          }

          a {
            font-weight: 600 !important;
            font-size: 0.875rem !important;
            color: $text-color !important;
            line-height: 120% !important;
          }
        }

        &:not(.image-post) {
          .j-text {
            justify-content: space-between;
          }
        }
      }
    }

    .juicer-feed.slider {
        .j-text {
            &::before {
              content: unset !important;
          }
        }
    }
  }
</style>
